export enum SelectedCourseEntryPoint {
  STUDY = 'study',
  TEST_PREP = 'testPrep',
  AUTO_SELECT = 'autoSelect',
}
